/* eslint-disable */
import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'next-i18next';
import Button, { BUTTON_THEME } from '@components/Button';
import {
  FieldInputWrapper,
  UploadInfo,
  ErrorMessage,
  SelectedFile,
  SelectedFileIcon,
} from '@components/ApplyModal/styles';
import PaperclipIcon from '@assets/images/icons/paperclip.svg';
import Image from 'next/image';

function FileUploadBox({ register, fieldName, onDropCallback, label, error, selectedFile }) {
  const { t } = useTranslation('offers');
  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    onDrop: onDropCallback,
    maxFiles: 1,
    multiple: false,
    maxSize: 5242880,
    accept: {
      'application/pdf': [],
      'application/msword': [],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [],
      'application/vnd.oasis.opendocument.text': [],
    },
  });

  const openSystemDialog: (event) => void = useCallback(
    (event) => {
      event.stopPropagation();
      event.preventDefault();
      open();
    },
    [open]
  );

  return (
    <FieldInputWrapper {...getRootProps()} error={!!error} isDragActive={isDragActive} onClick={openSystemDialog}>
      <input name={fieldName} {...register(fieldName)} type="file" {...getInputProps()} />
      <Button onClick={openSystemDialog} buttonTheme={BUTTON_THEME.SECONDARY}>
        {t('Upload')} {label}
      </Button>
      {selectedFile ? (
        <SelectedFile>
          <SelectedFileIcon>
            <Image src={PaperclipIcon} alt="" width={16} height={16} objectFit="contain" />
          </SelectedFileIcon>
          {selectedFile}
        </SelectedFile>
      ) : null}

      {!selectedFile ? (
        <>
          <UploadInfo>{isDragActive ? t('Drop here') : t('Drag here', { doc: label })}</UploadInfo>
          <UploadInfo>{t('offers:apply.filesize')}</UploadInfo>
        </>
      ) : null}

      {error ? <ErrorMessage>{error.message}</ErrorMessage> : null}
    </FieldInputWrapper>
  );
}

export default FileUploadBox;
